import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { newSubmission, Submission } from '../models/submission';

export interface ContactState {
    submission: Submission;
    choixDebutTravaux: string[],
    active: boolean,
    visible: boolean;
}

const initialState: ContactState = {
    submission: { ...newSubmission },
    choixDebutTravaux: [],
    active: false,
    visible: false
};

export const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        clear(state) {
            state.submission = { ...newSubmission };
        },
        updateSubmission(state, action: PayloadAction<Partial<Submission>>) {
            state.submission = { ...state.submission, ...action.payload };
        },
        setChoixDebutTravaux(state, action: PayloadAction<string[]>) {
            state.choixDebutTravaux = action.payload;
        },
        setActive(state, action: PayloadAction<boolean>) {
            state.active = action.payload;
        },
        setVisible(state, action: PayloadAction<boolean>) {
            state.visible = action.payload;
        }
    }
});
